const setColumnsOnBalanceSheet = ({ isBalanceSheet, setColumns, tableData }) =>
  isBalanceSheet ? { ...tableData, setColumns } : tableData;

export default setColumnsOnBalanceSheet;
